export const REQUIRED_MESSAGE = 'This field is mandatory';

export const NUMERIC_MESSAGE = 'Field should be numeric';

export const POSITIVE_MESSAGE = 'Field should be positive number';

export const ALPHABETIC_MESSAGE = 'Field should contain only letters';

export const ALPHA_NUMERIC_MESSAGE = 'Field should contain only letters and numbers';

export const ALPHA_NUMERIC_SPACE_MESSAGE = 'Field should contain only letters, numbers and space';
export const ALPHANUMERIC_DASH_DOT_MESSAGE = 'Field should contain only letters, numbers, dash and dot';
export const MIN_MESSAGE = 'Field should contain at least {{min}} characters';

export const MAX_MESSAGE = 'Field should contain maximum {{max}} characters';

export const MIN_MAX_MESSAGE = 'Field should contain at least {{min}} and maximum {{max}} characters';

export const MAX_NUMBER_MESSAGE = 'Field value should not be greater than {{max}}';
export const MIN_NUMBER_MESSAGE = 'Field value should not be less than {{min}}';
export const NOT_NEGATIVE_NUMBER_MESSAGE = 'Field should not be less than 0';

export const MIN_DATE_MESSAGE = 'Field should not be less than {{min}}';

export const MAX_DATE_MESSAGE = 'Field should not be greater than {{max}}';

export const TREATMENT_END_DATE_MESSAGE = 'Treatment End Date should not be earlier than Treatment Start Date';

export const LENGTH_MESSAGE = 'Field should contain {{length}} characters';

export const EMAIL_MESSAGE = 'Field should have valid email format';

export const ITEM_MIN_COUNT_MESSAGE = 'Need to have minimum 1 item';

export const PACKAGE_MIN_COUNT_MESSAGE = 'Need to have minimum 1 package';

export const MAX_LENGTH_MESSAGE = 'Field should contain {{length}} or less character';

export const MAX_FRACTION_MESSAGE = 'Field should contain maximum {{scale}} fraction digits';

export const MAX_INTEGER_AND_FRACTION_DIGIT_MESSAGE =
  'Field should contain maximum {{maxIntegralDigits}} integer digits and {{maxFractionalDigits}} fraction digits';

export const INVALID_VALUE_MESSAGE = 'Invalid value';

export const INVALID_PHONE_MESSAGE = 'Invalid phone number';

export const INVALID_VERSION_MESSAGE = 'The document has been updated by another user. Please refresh the page.';

export const OUT_OF_RANGE_COMMODITY_MESSAGE = 'Commodity code is out of range of License type Product List';
export const NOT_FOUND_COMMODITY_MESSAGE = 'Commodity code is not found';

export const SAME_QUOTA_TYPE_ERROR_MESSAGE =
  'You cannot select the same quota type twice. Please choose a different one.';
